<template>
  <div>
    <v-card-title>
      <template flat color="white">
        <div justify-end>
          <v-dialog v-model="dialog" max-width="350px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark v-on="on">Export registru</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Export</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-date-picker v-model="exportDates" range></v-date-picker>
                  </v-col>
                  <v-col cols="12">Date: {{ dateRangeText }}</v-col>
                </v-row>
                <v-row>
                  <v-btn color="blue darken-1" text @click="exportData('expenses/getCashRegister')">Exporta registru de
                    casa
                    [Excel]</v-btn>
                </v-row>
                <v-row>
                  <v-btn color="blue darken-1" text @click="exportData('expenses/getVATReport')">Exporta raport VAT
                    [Excel]</v-btn>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = !dialog">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-card-title>

    <v-layout>
      <v-flex>
        <v-btn color="primary" @click="showRecalculare = !showRecalculare">
          {{ showRecalculare ? 'Ascunde recalculare registru' : 'Recalculare registru' }}
        </v-btn>

        <div v-if="showRecalculare">
          <v-form ref="form">
            <v-menu ref="menuDate" v-model="menuDate" :close-on-content-click="false"
              :return-value.sync="cashRegister.date" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="cashRegister.date" label="Data" prepend-icon="event" readonly
                  v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="cashRegister.date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menuDate = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.menuDate.save(cashRegister.date)">OK</v-btn>
              </v-date-picker>
            </v-menu>

            <v-text-field label="Sold zi" v-model="cashRegister.profit"> </v-text-field>

            <div class="text-xs-right">
              <v-btn @click="submit" color="primary">Salvare</v-btn>
            </div>
          </v-form>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
import { busEvent } from '../../main';

export default {
  name: 'cash-register',
  data() {
    return {
      valid: true,
      menuDate: false,
      showRecalculare: false,
      cashRegister: {
        profit: 0,
        date: new Date().toISOString(),
      },
      dialog: false,
      exportDates: [this.startOfMonth(), this.endOfMonth()],
    };
  },
  computed: {
    dateRangeText() {
      return this.exportDates.join(' ~ ');
    },
  },
  methods: {
    submit() {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('expenses/updateCashRegister', this.cashRegister).then(() => {
          busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
        });
      }
    },
    async exportData(storeAction) {
      const response = await this.$store.dispatch(storeAction, {
        start: this.exportDates[0],
        end: this.exportDates[1],
      });

      const fileName = response.headers['content-disposition'].match('filename=(.*)')[1];
      saveAs(response.data, fileName);
    },
    startOfMonth() {
      const date = new Date();
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), 1)).toISOString().substr(0, 10);
    },
    endOfMonth() {
      const date = new Date();
      return new Date(Date.UTC(date.getFullYear(), date.getMonth() + 1, 0))
        .toISOString()
        .substr(0, 10);
    },
  },
};
</script>

<style></style>
